import { formatMoney, numericValue } from '../utils';

const calculatorBlock = (config) => {
    return {
        ...config,
        bankReceivables: null,
        costPerTransaction: null,
        averageTransaction: null,
        cardReceivables: null,
        cardRate: null,

        get currentCost() {
            const cost = this.calculateCost(this.costPerTransaction, this.cardRate);

            return !isFinite(cost) ? '---' : formatMoney(cost);
        },

        get flywireCost() {
            let cost = this.calculateCost(this.flywireCostPerTransaction, this.flywireCreditCardRate);

            return !isFinite(cost) ? '---' : formatMoney(cost);
        },

        get savings() {
            let currentCost = this.currentCost;
            let flywireCost = this.flywireCost;

            let savings = numericValue(currentCost) - numericValue(flywireCost);

            return !isFinite(savings) ? '---' : formatMoney(savings);
        },

        transferCost(cpt) {
            if (!cpt) {
                return 0;
            }
            let costPerTransaction = numericValue(cpt, 2);

            let cost =
                Math.ceil(numericValue(this.bankReceivables) / numericValue(this.averageTransaction)) *
                costPerTransaction;

            return Math.round(cost);
        },

        cardCost(cr) {
            if (!cr) {
                return 0;
            }
            let rate = cr;

            if (typeof cr == 'string') {
                let stringValue = cr.replace(',', '.').replaceAll('%', '');
                rate = parseFloat(stringValue);
            }

            let cost = (numericValue(this.cardReceivables) * rate) / 100;

            return Math.round(cost);
        },

        calculateCost(cpt, cr) {
            const transferCost = this.transferCost(cpt);
            const cardCost = this.cardCost(cr);

            const total = transferCost + cardCost;

            return Math.round(total);
        },
    };
};

export default calculatorBlock;
